import { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const STORAGE_PREFIX = "council:scroll:";

function storageKey(pathname: string, key: string) {
  return `${STORAGE_PREFIX}${key}:${pathname}`;
}

export default function ScrollManager() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const previous = useRef({ pathname: location.pathname, key: location.key });

  useLayoutEffect(() => {
    const previousLocation = previous.current;

    try {
      sessionStorage.setItem(storageKey(previousLocation.pathname, previousLocation.key), String(window.scrollY));
    } catch {
      // Scroll restoration is a UX enhancement; storage failures should never block navigation.
    }

    const restore = () => {
      if (navigationType === "POP") {
        const saved = sessionStorage.getItem(storageKey(location.pathname, location.key));
        window.scrollTo({ top: saved ? Number(saved) : 0, behavior: "auto" });
      } else if (!location.hash) {
        window.scrollTo({ top: 0, behavior: "auto" });
      }
    };

    requestAnimationFrame(restore);
    previous.current = { pathname: location.pathname, key: location.key };
  }, [location.key, location.pathname, location.hash, navigationType]);

  useLayoutEffect(() => {
    const saveCurrentPosition = () => {
      try {
        sessionStorage.setItem(storageKey(location.pathname, location.key), String(window.scrollY));
      } catch {
        // Ignore storage failures.
      }
    };

    window.addEventListener("pagehide", saveCurrentPosition);
    return () => window.removeEventListener("pagehide", saveCurrentPosition);
  }, [location.pathname, location.key]);

  return null;
}
